/**
 * Created by shubham on 8/5/18.
 */

import { NgModule} from '@angular/core';
import { Http} from '@angular/http';
import { MaterialModule,MdTabsModule } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown/angular2-multiselect-dropdown';
import { ActivateDeactivateModule } from '../../activate-deactivate-request/activate-deactivate-request.module';
import { AdminManagementRoutingModule } from './adminManagement-routing.module';
import { AdminManagementComponent } from './adminManagement.component';
import { AdminListComponent } from './adminList/adminList.component';
import { AddAdminComponent } from './addAdmin/addAdmin.component';
import { ViewAdminComponent } from './viewAdmin/viewAdmin.component';
import { TranslateModule,TranslateLoader,TranslateStaticLoader } from 'ng2-translate';
import { APPCONFIG } from '../../config';

@NgModule({
    imports: [
        MaterialModule,
        MdTabsModule,
        CommonModule,
        FormsModule,
        NgxDatatableModule,
        ReactiveFormsModule,
        AngularMultiSelectModule,
        ActivateDeactivateModule,
        AdminManagementRoutingModule,
        TranslateModule.forRoot({
            provide: TranslateLoader,
            //useFactory: (http: Http) => new TranslateStaticLoader(http, '/assets/i18n', '.json'),
            useFactory: (http: Http) => new TranslateStaticLoader(http, APPCONFIG.URL+APPCONFIG.translationUrl, '?v='+APPCONFIG.translationVersion),
            deps: [Http]
        })
    ],
    declarations: [
        AdminManagementComponent,
        AdminListComponent,
        AddAdminComponent,
        ViewAdminComponent
    ],
    exports: [
    ]
})

export class AdminManagementModule {}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/system-level-setting/adminManagement/adminManagement.module.ts